// extracted by mini-css-extract-plugin
export default {"highScores":"HighScores_highScores__iB9ox","scoreList":"HighScores_scoreList__6Ps-J","message":"HighScores_message__iwzN4","error":"HighScores_error__+6dXK"};